"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCreateMoveOutCXToKapi = void 0;
var core_1 = require("../../../../shared/core");
var getCountryFromRegion = function (region) {
    return region === 'AUS' ? 'AU' : 'GB';
}; //homemove use ISO 3166-1 alpha-2 country codes (will only accept GB in EU1 and AU in AP1)
var mapCreateMoveOutCXToKapi = function (_a, accountId) {
    var moveOutDate = _a.moveOutDate, forwardingAddress = _a.forwardingAddress;
    var retailer = core_1.configService.getConfig().retailer;
    return {
        accountId: accountId,
        moveOutDate: moveOutDate,
        forwardingAddress: forwardingAddress && __assign(__assign({}, forwardingAddress), { country: getCountryFromRegion(retailer.region) }),
    };
};
exports.mapCreateMoveOutCXToKapi = mapCreateMoveOutCXToKapi;
